export enum ArchiveState {
  Off = -1,
  NotReadyToCheck = 0,
  ReadyToCheck = 1,
  Checking = 2,
  Archiving = 3,
  Archived = 4,
  Error = 5,
  NotArchived = 6,
}
